import * as React from 'react';

const Bump24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16.997 21.776a.75.75 0 1 1 0 1.5h-10a.75.75 0 0 1 0-1.5zm-4.999-21a.75.75 0 0 1 .577.27l9.316 11.18c.679.815.1 2.05-.96 2.05h-3.183v3.75c0 .69-.56 1.25-1.25 1.25h-9c-.69 0-1.25-.56-1.25-1.25v-3.75H3.066c-1.06 0-1.638-1.235-.96-2.05l9.316-11.18a.75.75 0 0 1 .576-.27m-8.398 12h3.398a.75.75 0 0 1 .75.75v4.25h8.5v-4.25a.75.75 0 0 1 .75-.75h3.4l-8.4-10.078z"
  }
));
Bump24.Size = 24;
Bump24.Title = "Bump";

export { Bump24 as default };
